const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/privacy-policy.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { PrivacyPolicyQuery, type ZnglyInfo_PrivacyPolicy_Query } from '@/graphql/queries/ZnglyInfo.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { useAppStore } from '@/inertia/AppStore';
import { loadQuery } from 'react-relay';
export const Route = createFileRoute('/privacy-policy')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  onEnter: () => {
    useAppStore.setState({
      pageType: 'privacy-policy'
    });
  },
  loader: () => {
    return loadQuery<ZnglyInfo_PrivacyPolicy_Query>(RelayEnvironment, PrivacyPolicyQuery, {}, {
      fetchPolicy: 'store-or-network'
    });
  }
});